const sla_overview = {
	table: {
		dcid: "DCID",
		debtor_code: "Debiteurcode",
		hostname: "Hostnaam",
		name: "VPS Naam",
		node: "Node",
		sla: "SLA level",
		vmid: "VMID",
	},
	title: "SLA overzicht",
};

export default sla_overview;
